import { render, staticRenderFns } from "./notification-important.vue?vue&type=template&id=5805f10c&"
import script from "./notification-important.vue?vue&type=script&lang=js&"
export * from "./notification-important.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports